// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.CustomProgress[data-v-7219b28d]
	{
		display: inline-block;
		position: relative;
		width: 100px;
		block-size: 1em;
		inline-size: 10em;
		vertical-align: -0.2em;
		border: 1px solid #999999;
		box-sizing: border-box;
		overflow: hidden;
}
.CustomProgressTextContainer[data-v-7219b28d],
	.CustomProgressValue[data-v-7219b28d]
	{
		position: absolute;
		top: 0px;
		left: 0px;
		bottom: 0px;
		width: 100%;
		overflow: hidden;
		text-align: center;
		font-size: 1em;
		text-overflow: clip;
		white-space: nowrap;
}
.CustomProgressValue[data-v-7219b28d]
	{
		pointer-events: none;
		user-select: none;
		color: #000000;
}
.CustomProgressTextContainer[data-v-7219b28d]
	{
		color: #FFFFFF;
		user-select: all;
}
.CustomProgressText[data-v-7219b28d]
	{
		position: absolute;
		font-weight: bold;
		top: -0.2em;
		width: 100%;
}
`, "",{"version":3,"sources":["webpack://./www/vues/common/controls/CustomProgress.vue"],"names":[],"mappings":";AAsCC;;EAEC,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AACjB;AAEA;;;EAGC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACpB;AAEA;;EAEC,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AACf;AAEA;;EAEC,cAAc;EACd,gBAAgB;AACjB;AAEA;;EAEC,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,WAAW;AACZ","sourcesContent":["<template>\r\n\t<div class=\"CustomProgress\" :style=\"{ borderColor: borderColor }\" :title=\"title\">\r\n\t\t<div class=\"CustomProgressTextContainer\"><div class=\"CustomProgressText\">{{text}}</div></div>\r\n\t\t<div class=\"CustomProgressValue\" :style=\"{ width: value + '%', backgroundColor: color }\">\r\n\t\t\t<div class=\"CustomProgressText\" :style=\"{ width: (10000 / value) + '%' }\">{{text}}</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\texport default {\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tvalue: {\r\n\t\t\t\ttype: Number,\r\n\t\t\t\tdefault: 0\r\n\t\t\t},\r\n\t\t\tcolor: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"#008800\"\r\n\t\t\t},\r\n\t\t\tborderColor: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"#6068AB\"\r\n\t\t\t},\r\n\t\t\ttitle: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"\"\r\n\t\t\t},\r\n\t\t\ttext: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"\"\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.CustomProgress\r\n\t{\r\n\t\tdisplay: inline-block;\r\n\t\tposition: relative;\r\n\t\twidth: 100px;\r\n\t\tblock-size: 1em;\r\n\t\tinline-size: 10em;\r\n\t\tvertical-align: -0.2em;\r\n\t\tborder: 1px solid #999999;\r\n\t\tbox-sizing: border-box;\r\n\t\toverflow: hidden;\r\n\t}\r\n\r\n\t.CustomProgressTextContainer,\r\n\t.CustomProgressValue\r\n\t{\r\n\t\tposition: absolute;\r\n\t\ttop: 0px;\r\n\t\tleft: 0px;\r\n\t\tbottom: 0px;\r\n\t\twidth: 100%;\r\n\t\toverflow: hidden;\r\n\t\ttext-align: center;\r\n\t\tfont-size: 1em;\r\n\t\ttext-overflow: clip;\r\n\t\twhite-space: nowrap;\r\n\t}\r\n\r\n\t.CustomProgressValue\r\n\t{\r\n\t\tpointer-events: none;\r\n\t\tuser-select: none;\r\n\t\tcolor: #000000;\r\n\t}\r\n\r\n\t.CustomProgressTextContainer\r\n\t{\r\n\t\tcolor: #FFFFFF;\r\n\t\tuser-select: all;\r\n\t}\r\n\r\n\t.CustomProgressText\r\n\t{\r\n\t\tposition: absolute;\r\n\t\tfont-weight: bold;\r\n\t\ttop: -0.2em;\r\n\t\twidth: 100%;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
